import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { SecondaryButton } from '../../Shared/Button'

export default function CampaignActivationModal({ onCancel, onConfirm, status = 'activate', platform = null }) {
  const { t } = useTranslation()

  // platform set → per-platform confirmation copy ("Pause Google campaign?")
  // via its own translation keys, interpolating the platform's display name;
  // platform null → the existing combined cross-platform copy, unchanged.
  const statusKey = platform ? `platform${status[0].toUpperCase()}${status.slice(1)}` : status
  const platformName = platform ? t(`Recommendations.campaign.platformStatus.${platform}`) : undefined

  return (
    <div className="yes-no-prompt">
      <div className="yes-no-prompt_content">
        <h1>{t(`Recommendations.campaignActivationModal.${statusKey}.title`, { platform: platformName })}</h1>
        <p>{t(`Recommendations.campaignActivationModal.${statusKey}.description`, { platform: platformName })}</p>
      </div>
      <div className="yes-no-prompt_footer">
        <SecondaryButton
          text={t(`Recommendations.campaignActivationModal.${statusKey}.cancel`)}
          onClick={onCancel}
          color="navy"
        />
        <SecondaryButton
          className="bt"
          text={t(`Recommendations.campaignActivationModal.${statusKey}.confirm`)}
          onClick={onConfirm}
        />
      </div>
    </div>
  )
}

CampaignActivationModal.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  status: PropTypes.string.isRequired,
  platform: PropTypes.oneOf(['google', 'meta', null]),
}
